import type { Static } from "runtypes";
import { Record, String, Number, Union, Null, Array, Literal } from "runtypes";

export const WorkflowScheduleEntity = Record({
  name: String,
  value: String,
});

export type WorkflowScheduleEntity = Static<typeof WorkflowScheduleEntity>;

export const WorkflowSchedule = Record({
  id: String,
  userId: String,
  frequency: Union(Literal("daily"), Literal("weekly"), Literal("monthly"), Literal("one-time"), Literal("sequential-queue")),
  day: Union(Number, Null),
  desiredTime: Union(String, Null),
  desiredExecutionDate: Union(String, Null),
  intent: String,
  entities: Array(WorkflowScheduleEntity),
  creationDate: String,
  creationByUserId: String,
  lastUpdated: String,
  lastUpdatedByUserId: String,
  status: String,
});

export type WorkflowSchedule = Static<typeof WorkflowSchedule>;
